"use strict";

var _regeneratorRuntime = require("C:/Users/miemboli/Downloads/alfatauristudio-gatsby-master/alfatauristudio-gatsby-master/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _classCallCheck = require("C:/Users/miemboli/Downloads/alfatauristudio-gatsby-master/alfatauristudio-gatsby-master/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("C:/Users/miemboli/Downloads/alfatauristudio-gatsby-master/alfatauristudio-gatsby-master/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageDrawer = void 0;

var Utils_1 = require("../Utils");

var Enums_1 = require("../Enums");

var ImageDrawer = /*#__PURE__*/function () {
  function ImageDrawer() {
    _classCallCheck(this, ImageDrawer);

    this.images = [];
  }

  _createClass(ImageDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "getImages",
    value: function getImages(container) {
      var containerImages = this.images.filter(function (t) {
        return t.id === container.id;
      });

      if (!containerImages.length) {
        this.images.push({
          id: container.id,
          images: []
        });
        return this.getImages(container);
      } else {
        return containerImages[0];
      }
    }
  }, {
    key: "addImage",
    value: function addImage(container, image) {
      var containerImages = this.getImages(container);
      containerImages === null || containerImages === void 0 ? void 0 : containerImages.images.push(image);
    }
  }, {
    key: "init",
    value: function init(container) {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options, shapeOptions, imageOptions, _iterator, _step, optionsImage;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = container.options;
                shapeOptions = options.particles.shape;

                if (!(!Utils_1.Utils.isInArray(Enums_1.ShapeType.image, shapeOptions.type) && !Utils_1.Utils.isInArray(Enums_1.ShapeType.images, shapeOptions.type))) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                imageOptions = (_a = shapeOptions.options[Enums_1.ShapeType.images]) !== null && _a !== void 0 ? _a : shapeOptions.options[Enums_1.ShapeType.image];

                if (!(imageOptions instanceof Array)) {
                  _context.next = 25;
                  break;
                }

                _iterator = _createForOfIteratorHelper(imageOptions);
                _context.prev = 7;

                _iterator.s();

              case 9:
                if ((_step = _iterator.n()).done) {
                  _context.next = 15;
                  break;
                }

                optionsImage = _step.value;
                _context.next = 13;
                return this.loadImageShape(container, optionsImage);

              case 13:
                _context.next = 9;
                break;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](7);

                _iterator.e(_context.t0);

              case 20:
                _context.prev = 20;

                _iterator.f();

                return _context.finish(20);

              case 23:
                _context.next = 27;
                break;

              case 25:
                _context.next = 27;
                return this.loadImageShape(container, imageOptions);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 17, 20, 23]]);
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.images = [];
    }
  }, {
    key: "loadImageShape",
    value: function loadImageShape(container, imageShape) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var image;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!imageShape.replaceColor) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return Utils_1.Utils.downloadSvgImage(imageShape.src);

              case 4:
                _context2.t0 = _context2.sent;
                _context2.next = 10;
                break;

              case 7:
                _context2.next = 9;
                return Utils_1.Utils.loadImage(imageShape.src);

              case 9:
                _context2.t0 = _context2.sent;

              case 10:
                image = _context2.t0;
                this.addImage(container, image);
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t1 = _context2["catch"](0);
                console.warn("tsParticles error - ".concat(imageShape.src, " not found"));

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 14]]);
      }));
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius, opacity) {
      var _a, _b;

      if (!context) {
        return;
      }

      var image = particle.image;
      var element = (_a = image === null || image === void 0 ? void 0 : image.data) === null || _a === void 0 ? void 0 : _a.element;

      if (!element) {
        return;
      }

      var ratio = (_b = image === null || image === void 0 ? void 0 : image.ratio) !== null && _b !== void 0 ? _b : 1;
      var pos = {
        x: -radius,
        y: -radius
      };

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = opacity;
      }

      context.drawImage(element, pos.x, pos.y, radius * 2, radius * 2 / ratio);

      if (!(image === null || image === void 0 ? void 0 : image.data.svgData) || !(image === null || image === void 0 ? void 0 : image.replaceColor)) {
        context.globalAlpha = 1;
      }
    }
  }]);

  return ImageDrawer;
}();

exports.ImageDrawer = ImageDrawer;